import { Icon } from '@chakra-ui/react';

export const CloseIcon = (props: any) => (
  <Icon aria-label="close icon" viewBox="0 0 16 16" {...props}>
    <path
      d="m12.2426407.92893219 2.8284271 2.82842712-4.2431356 4.24257288 4.2431356 4.24270851-2.8284271 2.8284271-4.24270851-4.2431356-4.24257288 4.2431356-2.82842712-2.8284271 4.242-4.24270851-4.242-4.24257288 2.82842712-2.82842712 4.24257288 4.242z"
      fill="currentColor"
    />
  </Icon>
);
